import {inject} from 'aurelia-framework';
import { Api } from './services/api';
import { Request, DataService, AuthStatus, CookieDomain } from './services/data-service';
import { Router } from 'aurelia-router';

const AppEnviroment = { "Production":"production", "Dev":"dev" };
let   app_env		= AppEnviroment.Production;
const app_redirect 	= (app_env === AppEnviroment.Dev) ? "http://localhost:8082" : "https://app.samantia.com";


@inject(Api, DataService, Router)
export class Login {
	/** Component methods **/
	constructor(api, ds, router){
		this.api			= api;
		this.ds				= ds;
		this.formData 		= { username:"", email: "", password:""};
		this.authToken	 	= "";
		this.AuthStatus 	= AuthStatus;
		this.router			= router;
	}

	attached(){
		// Verify if auth token exists!
		//let token = this.getCookieByName("l5session");
		let token = this.getCookieByName("S6session");
		let request = new Request("/api/v2/sessions/id/", "GET");
		request.headers["Authorization"] = "Bearer" + token; // Bearer
		this.api.get(request).then(response => {

			if(response.status === 201){
				// redirect
				this.ds.user = response.data;
				this.ds.auth_status = AuthStatus.Ok;
				// this.router.navigateToRoute('user-detail', {id:response.data.uid} );

				//window.location.href = "http://localhost:8082"
				window.location.href = app_redirect;
			}
		});
	}

	/** Methods **/
	login(data){
		// Create Request
		let request = new Request("/api/v2/sessions/", "POST");
		request.body = JSON.stringify(data);
		this.api.post(request).then(response => {

			this.response	=  response;
			//let cookie_name = 'smt-6825067a94590c427262c566'
			let cookie_name	= 'S6session';

			if(response.status === 201){
				// Update variables
				this.auth_token = response.authToken;
				this.response = response;
				// Store cookie with authToken
				//let cookie = cookie_name + "=" + response.data.authToken + ";domain=localhost;path=/;SameSite=None;Secure";
				//let cookie = cookie_name + "=" + response.data.authToken + ";domain=samantia.com;path=/;SameSite=None;Secure";
				let cookie = cookie_name + "=" + response.data.authToken + CookieDomain;
				document.cookie = cookie;
				// Aunthenticate user
				this.ds.auth_status = AuthStatus.Ok;
				this.authToken = response.data.authToken;
				this.ds.user = response.data;
				//this.router.navigateToRoute('user-detail', {id:response.data.uid} );
				window.location.href = app_redirect;
			}
		});
	}// end login


	// Get cookies 
	getCookieByName(name){
		const match = document.cookie
			  .match(new RegExp("(^| )" + name + "=([^;]+)"));

		if (match) return match[2];
		return null;
		
	}// end cookie
	
}
